import { ModalWrapper } from 'src/components/ModalWrapper';
import { ShopModalContainer } from './components/ShopModalContainer';
import { useTranslation } from 'react-i18next';
import { Button } from 'src/components/Buttons/Button';
import { useModalContext } from 'src/hooks/useModalContext';
import { BuyMoney } from 'src/pages/Shop/AuthorizedShop/components/BuyMoney';
import { ModalProps } from './types';

export const NoCoinsForMoneyModal = () => {
  const { closeModal, openModal, modalProps } = useModalContext<ModalProps>();
  const { t } = useTranslation();
  const handleToHowToEarn = () => {
    closeModal();
    const freespinsInGames = document.getElementById('howToEarn');
    freespinsInGames?.scrollIntoView({
      behavior: 'smooth'
    });
  };

  return (
    <ModalWrapper showCross={false} isTransparentBg>
      <ShopModalContainer title="shop.noCoins" text="bonusPage.youDont">
        <div className="flex flex-col mb-[50px]">
          <BuyMoney item={modalProps?.item} />
          <Button
            className="w-[165px] self-center"
            onClick={() => {
              closeModal();
              openModal('DEPOSIT');
            }}>
            {t('accountBonus.deposit')}
          </Button>
          <p
            className="text-base underline text-center pt-5 text-sp_title font-bold cursor-pointer"
            onClick={handleToHowToEarn}>
            {t('bonusPage.howToEarn')}
          </p>
        </div>
      </ShopModalContainer>
    </ModalWrapper>
  );
};
